import React, { useState, useEffect, useReducer } from 'react';
import _ from 'lodash'
import { Link, useParams, useNavigate } from 'react-router-dom'
import ScrollView from 'devextreme-react/scroll-view';
import DataGrid, { Column, Lookup, RequiredRule, Editing, Item, ColumnFixing, FormItem, Paging, Pager, Export, ColumnChooser, Toolbar } from 'devextreme-react/data-grid';
import Header from '../header/Header'
import Footer from '../footer/Footer'
import { postUserLog } from '../../actions/common'
import * as utils from '../../common/utils'
import * as actions from '../../actions/siteDetails';
import siteReducer from '../../reducers/siteDetails';
import { Toast } from 'devextreme-react/toast';
const initialState = { siteLocations: [], tiers: [], userData: null, pinSiteStatus: null, pinnedSites: [], kcategories: [], categorySave: null };
const configs = {
    noDataText: "No Data.",
        showBorders: true,
            rowAlternationEnabled: true,
                allowColumnReordering: true,
                    allowColumnResizing: true,
                        columnResizingMode: "widget",
                            columnAutoWidth: true,
                                columnChooser: {
        enabled: true,
            allowSearch: true,
                mode: "select"
    },
    headerFilter: {
        visible: true
    },
    sorting: {
        mode: "multiple"
    },
    grouping: {
        contextMenuEnabled: true
    },
    searchPanel: {
        visible: true
    },
    filterRow: {
        visible: true,
            applyFilter: "auto"
    },
    
    export: {
        enabled: true,
            fileName: "Category"
    },

    onToolbarPreparing: function (e) {
        var dataGrid = e.component;
        var toolbarItems = e.toolbarOptions.items;
        // Adds a new item
        toolbarItems.unshift(
            {
                location: "after",
                widget: "dxButton",
                options: {
                    icon: "refresh",
                    hint: "Refresh",
                    onClick: function () {
                        dataGrid.refresh();
                    }
                }
            });
    }
}

export default () => {
    const { category, app, site } = useParams();
    const navigate = useNavigate()
    const [state, dispatch] = useReducer(siteReducer, initialState);
    const { siteLocations, pinnedSites, userData, kcategories, categorySave } = state
    const [animate, setAnimate] = useState('animate');
    const [toastConfig, setToastConfig] = useState({
        isVisible: false,
        type: 'info',
        message: '',
    });
    const scrollConfig = {
        showScrollbar: 'always',
        scrollByContent: false,
        scrollByThumb: true,
    }

    useEffect(() => {
        actions.getKCategory(dispatch, site);
        actions.getUserData(dispatch, site);
        actions.fetchSiteLocations(dispatch, category);
        actions.fetchPinnedSites(dispatch, category);

    }, []);

    useEffect(() => {

        if (categorySave && categorySave == -1) {
            setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: 'warning',
                message: 'Category already exist.'
            });
        }

        if (categorySave && categorySave > 0) {
            setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: 'success',
                message: 'Category saved.'
            });
        }

    }, [categorySave]);

    const onRowUpdated = (data) => {
        let { category, active, priority, id } = data.data
        let siteId = site;
        let input = { category, active, priority, siteId, id }
        actions.updateKCate(dispatch, input, siteId);
    }

    const onRowInserted = (data) => {
        let { category, active, priority } = data.data
        let id = 0, siteId = site;
        let input = { id, category, active, priority, siteId }
        actions.updateKCate(dispatch, input, siteId)
    }
    function onHiding() {
        setToastConfig({
            ...toastConfig,
            isVisible: false,
        });
    }


    const onRowRemoved = (data) => {
        actions.delKCate(dispatch, data.data.id, site)
    }

    const handlers = {
        onRowUpdated: onRowUpdated,
        onRowRemoved: onRowRemoved,
        onRowInserted: onRowInserted
    }


    const updatePinSite = () => {
        let site = getSitInfo();
        let isPinned = site.isPinned ? false : true;
        let pinStatus = isPinned ? 'pinned' : 'unpinned';
        actions.updatePinSite(dispatch, `siteid=${site.siteId}&pinned=${isPinned}`, category);
        postUserLog({ event: 'Pin/UnPin Site', data: { action: site.siteName + ' site ' + pinStatus, module: 'Tier Screen', section: 'Header', siteUId: site.siteId, widget: '', } })
    }
    const getSitInfo = () => {
        let data = _.find(siteLocations, ['siteId', site]);
        return data
    }

    const getSiteName = () => {

        let data = getSitInfo();
        return data ? data.siteName : '';

    }


    return (
        <>
            <Header showPinBtn={updatePinSite} site={getSitInfo()} />
            <section className="page-content">
                <div className="site-view tier-wrap">
                    <div className={"site-list " + animate}>
                        <div className="breadcrumb">
                            <span className={"icon icon-" + utils.getSbgName(category)}></span>
                            <ul>
                                <li><Link to={`/home/${category}`} onClick={() => { postUserLog({ event: 'SBG Clicked', data: { action: 'Navigates to ' + utils.getSbgNameTxt(category) + ' Site Selection Screen', module: 'Tier Screen', section: 'BreadCrumb', siteUId: site, widget: '', } }) }}>{utils.getSbgNameTxt(category)}</Link></li>
                                <li><Link to={`/sitehome/${category}/${site}`} onClick={() => { postUserLog({ event: 'Site Clicked', data: { action: 'Navigates to ' + getSiteName() + ' Site Home Screen', module: 'Tier Screen', section: 'BreadCrumb', siteUId: site, widget: '', } }) }}>{getSiteName()}</Link></li>
                                <li><Link to={`/siteApp/${category}/${site}/kaizen`} onClick={() => { postUserLog({ event: 'Site Clicked', data: { action: 'Navigates to ' + getSiteName() + ' Site Home Screen', module: 'Tier Screen', section: 'BreadCrumb', siteUId: site, widget: '', } }) }}>Kaizen</Link></li>
                                <li><Link to={`/siteApp/${category}/${site}/kaizenAdmin`} onClick={() => { postUserLog({ event: 'Site Clicked', data: { action: 'Navigates to ' + getSiteName() + ' Site Home Screen', module: 'Tier Screen', section: 'BreadCrumb', siteUId: site, widget: '', } }) }}>Admin</Link></li>
                                <li>Category</li>
                            </ul>
                        </div>
                        <div className="site-head">
                            <div className="page-heading">
                                <h2><span className={"icon action"}></span>Category</h2>
                            </div>
                        </div> {userData && <div className="site-body scroll">
                            <ScrollView
                                id="siteApps"
                                {...scrollConfig}
                            >
                                <div className="site-body w-100" >
                                    <DataGrid
                                        dataSource={kcategories}
                                        {...configs}
                                        {...handlers}
                                    >
                                        <Paging defaultPageSize={10} /><Pager
                                            visible={true}
                                            allowedPageSizes={[5, 10, 20, 50]}
                                            showPageSizeSelector={true}
                                            showInfo={true}
                                            showNavigationButtons={true} />
                                        <Editing mode="batch" allowUpdating={true} allowAdding={true} allowDeleting={true}  useIcons={true} ></Editing>
                                        <Column dataField="id" dataType="number" caption="ID" allowEditing={false} visible={false} />
                                        <Column caption="Category" dataField="category" dataType="string" validationRules={[{ type: "required" }]} />
                                        <Column caption="Active" dataField="active" dataType="string" validationRules={[{ type: "required" }]} ><Lookup  dataSource={['Y', 'N']}/></Column>
                                        <Column caption="Priority" dataField="priority" dataType="number" validationRules={[{ type: "required" }]}  />
                                    </DataGrid>
                                </div>
                            </ScrollView>
                        </div>
                        }
                    </div>
                </div>
            </section><Footer showThemeSwitch={true} hideSiteCount={true} activeSites={pinnedSites} sbg={category} />
            <Toast
                visible={toastConfig.isVisible}
                message={toastConfig.message}
                type={toastConfig.type}
                onHiding={onHiding}
                displayTime={2000}
            />
        </>
    );
}